// src/services/athleteDataService.js
/**
 * Central service for managing athlete data across the application
 * This allows adding/modifying athletes in one place and reflecting changes everywhere
 */

import { video } from "framer-motion/client";

// Main athletes database
const athletes = [
  {
    id: 1,
    name: "ANTHONY AOKI",
    fullName: "Anthony Tadashi Aoki Nakama",
    team: "Alianza Universidad",
    image: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/Tadashi_aoki_01.png",
    image2: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/aoki2.png",
    video: ["https://www.youtube.com/watch?v=qAecsvtQWLM"],
    transfer: "https://www.transfermarkt.pe/anthony-aoki/profil/spieler/491559",
    country: "PE",
    secondCountry: "JP",
    countryCode: "PE & JP",
    secondCountryCode: "JP",
    birthDate: "08/06/2000",
    birthPlace: "Lima",
    height: "1.79",
    age: 24,
    position: "Mediocampista",
    specificPosition: "Pivote",
    foot: "Derecho",
    number: "21",
    marketValue: "275 mil €",
    highlights: ["Mejor futbolista de la temporada 23/24", "Campeón de la Segunda División de Perú 2024", "Selección Perú Sub-17"],
    category: "mediocampista",
    stats: {
      matches: 28,
      goals: 0,
      assists: 0,
      yellowCards: 3,
      redCards: 0,
      minutesPlayed: 2345,
      passAccuracy: 87
    },
    careerHistory: [
      { season: "14/15", club: "Deportivo AELU", value: "-", transferType: "?" },
      { season: "17/18", club: "Cristal Sub20", value: "-", transferType: "-" },
      { season: "19/20", club: "Sporting Cristal II", value: "150 mil €", transferType: "Cesión" },
      { season: "19/20", club: "Unión Huaral", value: "150 mil €", transferType: "Fin de cesión" },
      { season: "19/20", club: "Sporting Cristal II", value: "150 mil €", transferType: "Cesión" },
      { season: "19/20", club: "Ayacucho FC", value: "150 mil €", transferType: "Cesión" },
      { season: "21/22", club: "Sporting Cristal II", value: "200 mil €", transferType: "Fin de cesión" },
      { season: "21/22", club: "Alianza UDH", value: "200 mil €", transferType: "Libre" }
    ],
    contract: {
      signed: "16/02/2022",
      until: "31/12/2025",
      lastRenewal: "07/11/2024"
    },
    socialMedia: {
      twitter: true,
      instagram: true
    },
    agent: "REDDE",
    competitions: ["Liga 1 Apertura", "Primera categoría"],
    featured: true
  },
  {
    id: 2,
    name: "JUANMA DELGADO",
    fullName: "Juan Manuel Delgado Lloria",
    team: "V-Varen Nagasaki",
    image: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/juanma_delgado_01.png",
    image2: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/sebastian2.png",
    video: ["https://youtu.be/WWMtHJom0nw"],
    transfer: "https://www.transfermarkt.es/juanma-delgado/leistungsdaten/spieler/229263/saison/2024/plus/1#gesamt",
    country: "ES",
    countryCode: "ES",
    birthDate: "17/11/1990",
    birthPlace: "Valencia",
    height: "1.88",
    age: 34,
    position: "Delantero",
    specificPosition: "Delantero centro",
    foot: "Derecho",
    number: "9",
    marketValue: "400 mil €",
    marketValueHighest: "1,00 mill. €",
    marketValueHighestDate: "28/12/2019",
    highlights: ["J2 League"],
    category: "delantero",
    stats: {
      matches: 30,
      goals: 15,
      assists: 4,
      yellowCards: 2,
      redCards: 0,
      minutesPlayed: 2600,
      passAccuracy: 75
    },
    careerHistory: [
      { season: "09/10", club: "Levante Juv. A", value: "-", transferType: "Libre" },
      { season: "11/12", club: "Jove Español", value: "-", transferType: "Libre" },
      { season: "12/13", club: "CD Dénia", value: "-", transferType: "Libre" },
      { season: "13/14", club: "Alavés", value: "-", transferType: "Libre" },
      { season: "14/15", club: "Asteras Tripoli", value: "400 mil €", transferType: "Libre" },
      { season: "15/16", club: "AEL Kalloni", value: "500 mil €", transferType: "Libre" },
      { season: "16/17", club: "Heart of Midl.", value: "500 mil €", transferType: "Cesión" },
      { season: "16/17", club: "UCAM Murcia", value: "400 mil €", transferType: "Fin de cesión" },
      { season: "16/17", club: "Heart of Midl.", value: "400 mil €", transferType: "?" },
      { season: "18/19", club: "V.V. Nagasaki", value: "600 mil €", transferType: "Libre" },
      { season: "19/20", club: "Omiya Ardija", value: "1,00 mill. €", transferType: "Libre" },
      { season: "22/23", club: "Avispa Fukuoka", value: "650 mil €", transferType: "?" },
      { season: "22/23", club: "V.V. Nagasaki", value: "400 mil €", transferType: "?" }
    ],
    contract: {
      signed: "09/01/2023",
      until: "31/12/2025",
      lastRenewal: "12/12/2024"
    },
    agent: "ACSM",
    competitions: ["J2 League", "Segunda categoría"],
    featured: true
  },
  {
    id: 3,
    name: "TIAGO ALVES",
    fullName: "Tiago Alves",
    team: "Uthai Thani FC",
    image: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/thiago_alves_01.png",
    image2: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/thiago2.png",
    video: ["https://www.youtube.com/watch?v=r_GLLUQb_fo"],
    transfer: "https://www.transfermarkt.pe/tiago-alves/profil/spieler/177011",
    country: "BR",
    countryCode: "BR",
    height: "1.81",
    age: 31,
    position: "Delantero",
    specificPosition: "Delantero",
    foot: "Zurdo",
    number: "9",
    highlights: ["Thailand Premier League", "Copa del Rey de Tailandia"],
    category: "delantero",
    stats: {
      matches: 32,
      goals: 18,
      assists: 5,
      yellowCards: 4,
      redCards: 0,
      minutesPlayed: 2800,
      passAccuracy: 76
    },
    careerHistory: [
      { season: "11/14", club: "Santos F.C.", value: "-", transferType: "-" },
      { season: "2012", club: "Boa E.C.", value: "-", transferType: "-" },
      { season: "2013", club: "América F.C.", value: "-", transferType: "-" },
      { season: "2014", club: "C.A. Paranaense / Paraná Clube", value: "-", transferType: "-" },
      { season: "15/16", club: "A. Paranaense", value: "-", transferType: "-" },
      { season: "2015", club: "Pohang Steelers", value: "-", transferType: "-" },
      { season: "2016", club: "Seongnam F.C.", value: "-", transferType: "-" },
      { season: "16/18", club: "Al-Hilal Saudi F.C.", value: "-", transferType: "-" },
      { season: "2017", club: "Shimizu S-Pulse", value: "-", transferType: "-" },
      { season: "18/19", club: "Jeonbuk Hyundai Motors", value: "-", transferType: "-" },
      { season: "2019", club: "Sagan Tosu", value: "-", transferType: "-" },
      { season: "2020", club: "Sagan Tosu", value: "-", transferType: "-" },
      { season: "2021", club: "Gamba Osaka", value: "-", transferType: "-" },
      { season: "22/23", club: "Fagiano Okayama", value: "-", transferType: "-" },
      { season: "2024", club: "Capecoense", value: "-", transferType: "-" },
      { season: "2025", club: "Uthai Thani F.C.", value: "-", transferType: "-" }
    ],
    featured: true
  },
  {
    id: 4,
    name: "PEDRO YNAMINE",
    fullName: "Pedro Andre Shigueishi Ynamine Kitano",
    team: "Alianza Universidad",
    image: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/pedro_ynamine_01.png",
    image2: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/pedro2.png",
    video: ["https://youtu.be/gzkni6P37GM"],
    transfer: "https://www.transfermarkt.pe/pedro-ynamine/profil/spieler/480521",
    country: "PE",
    countryCode: "PE",
    birthDate: "14/10/1998",
    birthPlace: "Lima",
    height: "1.85",
    age: 26,
    position: "Portero",
    specificPosition: "Portero",
    foot: "Izquierdo",
    number: "1",
    marketValue: "300 mil €",
    agent: "Familiar",
    highlights: ["Liga 1 Apertura", "Perú Sub-23"],
    category: "portero",
    stats: {
      matches: 26,
      goals: 0,
      assists: 0,
      yellowCards: 2,
      redCards: 0,
      minutesPlayed: 2340,
      passAccuracy: 72,
      cleanSheets: 10,
      savePercentage: 78,
      internationalMatches: 3,
      internationalGoals: 0
    },
    careerHistory: [
      { season: "15/16", club: "San Martín U20", value: "-", transferType: "?" },
      { season: "16/17", club: "Sport Boys", value: "-", transferType: "?" },
      { season: "17/18", club: "U San Martín II", value: "75 mil €", transferType: "-" },
      { season: "21/22", club: "U. San Martín", value: "125 mil €", transferType: "?" },
      { season: "22/23", club: "UTC", value: "200 mil €", transferType: "Libre" },
      { season: "23/24", club: "U. San Martín", value: "250 mil €", transferType: "Libre" },
      { season: "23/24", club: "Alianza UDH", value: "300 mil €", transferType: "Libre" }
    ],
    contract: {
      signed: "01/02/2024",
      until: "31/12/2025",
      lastRenewal: "06/11/2024"
    },
    featured: false
  },
  {
    id: 5,
    name: "NILTON RAMIREZ",
    fullName: "Nilton Cesar Junior Ramirez Barrera",
    team: "Alianza Universidad",
    image: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/Nilton_ramirez_01.png",
    image2: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/nilton2.png",
    video: ["https://youtu.be/RzKpgoPWTZs"],
    transfer: "https://www.transfermarkt.pe/nilton-ramirez/profil/spieler/1107110",
    country: "PE",
    countryCode: "PE",
    birthDate: "08/08/2005",
    birthPlace: "Huánuco",
    height: "1.69",
    age: 19,
    position: "Medio campo",
    specificPosition: "Medicentro",
    secondaryPosition: "Extremo derecho",
    tertiaryPosition: "Medicentro ofensivo",
    foot: "Derecho",
    number: "15",
    marketValue: "325 mil €",
    highlights: ["Perú S20"],
    category: "mediocampista",
    stats: {
      matches: 32,
      goals: 5,
      assists: 8,
      yellowCards: 4,
      redCards: 0,
      minutesPlayed: 2650,
      passAccuracy: 84,
      internationalMatches: 0,
      internationalGoals: 0
    },
    careerHistory: [
      { season: "20/21", club: "León de Huánuco", value: "-", transferType: "Libre" },
      { season: "21/22", club: "Miguel Grau UDH", value: "-", transferType: "Libre" },
      { season: "21/22", club: "León de Huánuco", value: "-", transferType: "Libre" },
      { season: "22/23", club: "Alianza UDH II", value: "-", transferType: "Libre" },
      { season: "22/23", club: "Alianza UDH", value: "-", transferType: "-" }
    ],
    contract: {
      signed: "07/02/2023",
      until: "31/12/2025",
      lastRenewal: "31/12/2023"
    },
    featured: false
  },
  {
    id: 6,
    name: "MATÍAS CANAHUALPA",
    fullName: "Juan Matías Canahualpa Farro",
    team: "Deportivo Llacuabamba",
    image: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/Matias_Canahualpa_01.png",
    image2: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/mathias2.png",
    transfer: "https://www.transfermarkt.pe/matias-canahualpa/profil/spieler/1386970",
    country: "PE",
    countryCode: "PE",
    birthDate: "2005",
    birthPlace: "Trujillo",
    height: "1.75",
    age: 20,
    position: "Medio campo",
    specificPosition: "Medio campo",
    foot: "Derecho",
    number: "26",
    category: "mediocampista",
    stats: {
      matches: 15,
      goals: 1,
      assists: 2,
      yellowCards: 3,
      redCards: 0,
      minutesPlayed: 1200,
      passAccuracy: 80
    },
    careerHistory: [
      { season: "24/25", club: "At. Grau II", value: "-", transferType: "Libre" },
      { season: "24/25", club: "Llacuabamba", value: "-", transferType: "Libre" }
    ],
    contract: {
      signed: "18/03/2025",
      until: "31/12/2025"
    },
    featured: false
  },
  {
    id: 7,
    name: "SERIGNE SALIOU DIOP",
    fullName: "Serigne Saliou Diop",
    team: "V-Varen Nagasaki",
    image: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/serigne_saliou_01.PNG", // Placeholder path - update with actual image path
    image2: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/serigne2.png",
    transfer: "https://www.transfermarkt.pe/serigne-saliou-diop/profil/spieler/1109766",
    country: "JP",
    countryCode: "JP",
    birthDate: "30/06/2003",
    birthPlace: "Kanagawa",
    height: "1.95",
    age: 21,
    position: "Delantero",
    specificPosition: "Delantero centro",
    foot: "Derecho",
    number: "32",
    marketValue: "75 mil €",
    marketValueHighest: "100 mil €",
    marketValueHighestDate: "22/02/2024",
    highlights: ["J2 League"],
    category: "delantero",
    stats: {
      matches: 1,
      goals: 0,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      minutesPlayed: 0,
      passAccuracy: 0
    },
    careerHistory: [
      { season: "22/23", club: "Nagoya Sangyo U", value: "-", transferType: "Libre" },
      { season: "23/24", club: "V.V. Nagasaki", value: "100 mil €", transferType: "Cesión" },
      { season: "24/25", club: "Matsumoto Yama.", value: "100 mil €", transferType: "Fin de cesión" },
      { season: "24/25", club: "V.V. Nagasaki", value: "100 mil €", transferType: "Cesión" }
    ],
    contract: {
      signed: "17/02/2023",
      until: "31/01/2026",
      lastRenewal: "12/12/2024"
    },
    agent: "Massa Corporation",
    competitions: ["J2 League", "Segunda categoría"],
    featured: false
    },
    {
      id: 8,
      name: "MALCOLM MOYO",
      fullName: "Malcolm Tsuyoshi Moyo",
      team: "Portimonense SC",
      image: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/MOYO_03.png", // Actualizar con la imagen real
      image2: "https://pub-8b7376b23b5a4b558c0089505b9b4b8e.r2.dev/segine2.png", // Actualizar con imagen en acción
      video: ["https://youtu.be/xe-MsA2V-EM"],
      transfer: "https://www.transfermarkt.pe/malcolm-tsuyoshi-moyo/profil/spieler/797557",
      country: "JP",
      countryCode: "JP",
      birthDate: "03/06/2001",
      birthPlace: "Osaka",
      height: "1.81",
      age: 23,
      position: "Defensa",
      specificPosition: "Lateral derecho",
      foot: "Derecho",
      number: "27",
      marketValue: "275 mil €",
      marketValueHighest: "275 mil €",
      marketValueHighestDate: "12/12/2024",
      highlights: ["Japón U19", "J2 League", "Copa J. League", "Copa del Emperador"],
      category: "defensa",
      stats: {
        matches: 29,
        goals: 0,
        assists: 1,
        yellowCards: 0, // Ajustar si se conoce
        redCards: 0, // Ajustar si se conoce
        minutesPlayed: 1899, // Suma de: 1693 (J2) + 116 (Copa J) + 90 (Copa Emperador)
        passAccuracy: 80 // Ajustar si se conoce
      },
      careerHistory: [
        { season: "19/20", club: "Hig. Fukuoka HS", value: "-", transferType: "Libre" },
        { season: "23/24", club: "Hosei Univ.", value: "-", transferType: "Libre" },
        { season: "24/25", club: "V.V. Nagasaki", value: "-", transferType: "Libre" },
        { season: "24/25", club: "Fujieda MYFC", value: "250 mil €", transferType: "Cesión" },
        { season: "24/25", club: "V.V. Nagasaki", value: "275 mil €", transferType: "Fin de cesión" },
        { season: "24/25", club: "Portimonense", value: "275 mil €", transferType: "Cesión" },
        { season: "24/25", club: "V.V. Nagasaki", value: "275 mil €", transferType: "Fin de cesión" } // Regreso futuro
      ],
      contract: {
        signed: "03/02/2025", // Fecha de cesión al Portimonense
        until: "30/06/2025", // Fecha fin de cesión
        lastRenewal: "03/02/2025"
      },
      loanInfo: {
        fromClub: "V-Varen Nagasaki",
        untilDate: "30/06/2025",
        parentContractUntil: "31/01/2026"
      },
      agent: "ACSM", // Ajustar si se conoce el agente
      competitions: ["Liga Portugal 2", "Segunda categoría"],
      featured: false
    }
];



// Categories for filtering
const categories = [
  { id: 'all', name: 'Todos' },
  { id: 'portero', name: 'Porteros' },
  { id: 'defensa', name: 'Defensas' },
  { id: 'mediocampista', name: 'Mediocampistas' },
  { id: 'delantero', name: 'Delanteros' }
];

/**
 * Get all athletes from the database
 * @returns {Array} All athletes
 */
export const getAllPlayers = () => {
  return [...athletes];
};

/**
 * Get a specific athlete by ID
 * @param {number} id - The athlete's ID
 * @returns {Object|null} The athlete object or null if not found
 */
export const getPlayerById = (id) => {
  id = parseInt(id);
  return athletes.find(athlete => athlete.id === id) || null;
};

/**
 * Get featured athletes
 * @param {number} limit - Maximum number of athletes to return
 * @returns {Array} Featured athletes
 */
export const getFeaturedPlayers = (limit = 3) => {
  return athletes
    .filter(athlete => athlete.featured)
    .slice(0, limit);
};

/**
 * Filter athletes by category
 * @param {string} category - Category to filter by (or 'all' for all categories)
 * @returns {Array} Filtered athletes
 */
export const getPlayersByCategory = (category = 'all') => {
  if (category === 'all') {
    return [...athletes];
  }
  return athletes.filter(athlete => athlete.category === category);
};

/**
 * Search athletes by name, team or position
 * @param {string} searchTerm - Term to search for
 * @returns {Array} Matching athletes
 */
export const searchPlayers = (searchTerm = '') => {
  if (!searchTerm.trim()) {
    return [...athletes];
  }
  
  const normalizedTerm = searchTerm.toLowerCase().trim();
  
  return athletes.filter(athlete => {
    return (
      athlete.name.toLowerCase().includes(normalizedTerm) ||
      athlete.team.toLowerCase().includes(normalizedTerm) ||
      athlete.position.toLowerCase().includes(normalizedTerm) ||
      (athlete.specificPosition && athlete.specificPosition.toLowerCase().includes(normalizedTerm))
    );
  });
};

/**
 * Get all categories for filtering
 * @returns {Array} Categories
 */
export const getCategories = () => {
  return [...categories];
};

/**
 * Get players by team
 * @param {string} teamName - Name of the team
 * @returns {Array} Players in the specified team
 */
export const getPlayersByTeam = (teamName) => {
  return athletes.filter(athlete => 
    athlete.team.toLowerCase() === teamName.toLowerCase()
  );
};

/**
 * Get URL for country flag
 * @param {string} countryCode - Two-letter country code (e.g., 'PE', 'JP')
 * @returns {string} URL for the country flag
 */
export const getFlagUrl = (countryCode) => {
  return `https://flagsapi.com/${countryCode}/shiny/64.png`;
};

/**
 * Get number of players by category
 * @returns {Object} Count of players in each category
 */
export const getPlayerCountByCategory = () => {
  const counts = { all: athletes.length };
  
  categories.forEach(category => {
    if (category.id !== 'all') {
      counts[category.id] = athletes.filter(a => a.category === category.id).length;
    }
  });
  
  return counts;
};

/**
 * Add a new athlete to the database
 * @param {Object} athleteData - Data for the new athlete
 * @returns {Object} The newly added athlete
 */
export const addAthlete = (athleteData) => {
  // Generate a new ID (typically this would be handled by a real database)
  const newId = Math.max(...athletes.map(a => a.id)) + 1;
  
  const newAthlete = {
    id: newId,
    ...athleteData
  };
  
  athletes.push(newAthlete);
  return newAthlete;
};

/**
 * Update an existing athlete
 * @param {number} id - ID of the athlete to update
 * @param {Object} athleteData - Updated data
 * @returns {Object|null} The updated athlete or null if not found
 */
export const updateAthlete = (id, athleteData) => {
  id = parseInt(id);
  const index = athletes.findIndex(a => a.id === id);
  
  if (index === -1) {
    return null;
  }
  
  athletes[index] = {
    ...athletes[index],
    ...athleteData
  };
  
  return athletes[index];
};

/**
 * Delete an athlete
 * @param {number} id - ID of the athlete to delete
 * @returns {boolean} Success status
 */
export const deleteAthlete = (id) => {
  id = parseInt(id);
  const initialLength = athletes.length;
  
  const newAthletes = athletes.filter(a => a.id !== id);
  
  // Update the reference (in a real implementation with a DB, this would be a DB operation)
  athletes.length = 0;
  athletes.push(...newAthletes);
  
  return athletes.length !== initialLength;
};

export default {
  getAllPlayers,
  getPlayerById,
  getFeaturedPlayers,
  getPlayersByCategory,
  searchPlayers,
  getCategories,
  getPlayersByTeam,
  getFlagUrl,
  getPlayerCountByCategory,
  addAthlete,
  updateAthlete,
  deleteAthlete
};